import React, { useState } from "react";
import clsx from "clsx";
import { isEmpty } from "lodash";
import { useFormContext } from "react-hook-form";

import { HookFormInputGroup } from "components";
import { getCreditCardType } from "mappers";
import { CreditCardTypes } from "types/enums";
import { trimNormalizer } from "validators";
import {
	applyValidatorsIf,
	normalizeAll,
	onlyDigits,
	onlyMaxAlphaNumeric19,
	required,
	validCreditCard,
} from "validators/validation";

import { getModalInputStyles } from "./getModalStyles";
import {
	cardNumberFieldName,
	cardTypeFieldName,
} from "./paymentMethodConstants";

import styles from "./paymentMethod.module.scss";

type CreditCardNumberProps = {
	isLoading: boolean;
	defaultValues: { [key: string]: any };
	isModal: boolean;
};

const CreditCardNumber = ({
	isLoading,
	defaultValues,
	isModal,
}: CreditCardNumberProps) => {
	const {
		register,
		formState: { errors },
		setValue,
	} = useFormContext();

	const [creditCardType, setCreditCardType] = useState<string>(
		CreditCardTypes.getByValue(defaultValues?.cardType)?.name || "",
	);

	const handleCardNumberChange = e => {
		const creditCardTypeName = getCreditCardType(e.target.value);
		setCreditCardType(creditCardTypeName);
		setValue(cardTypeFieldName, creditCardTypeName);
	};

	const isCreditCardCustomerId = !isEmpty(defaultValues?.customerId);

	const inputStyle = getModalInputStyles(isModal);

	return (
		<>
			<HookFormInputGroup
				className={clsx(isModal && styles.modalFormGroupIcon)}
				name={cardNumberFieldName}
				iconName={creditCardType}
				register={register}
				label="Card Number"
				colInput={inputStyle}
				colLabel={inputStyle}
				blurLoading={isLoading}
				autoComplete="off"
				normalizeOnBlur={trimNormalizer}
				errors={errors}
				validator={applyValidatorsIf(() => !defaultValues?.cardNumber)([
					required,
					validCreditCard,
				])}
				normalize={normalizeAll([onlyMaxAlphaNumeric19, onlyDigits])}
				onChange={handleCardNumberChange}
				showRequiredMark
				isPlainText={isCreditCardCustomerId}
				disabled={isCreditCardCustomerId}
			/>
			<HookFormInputGroup
				name={cardTypeFieldName}
				register={register}
				hidden
			/>
		</>
	);
};

export default CreditCardNumber;
